function RailBlock({ eyebrow, top = false, borderTop = true, children }) {
  return (
    <div className={`${top ? '' : 'mt-7'} pt-4 ${borderTop ? 'border-t border-soft-rule' : ''}`}>
      <p className="font-mono text-[10.5px] uppercase tracking-[0.8px] text-soft-faint mb-4">
        {eyebrow}
      </p>
      {children}
    </div>
  )
}

export default RailBlock
